<template>
  <button class="btn btn-green w-100 mb-3" @click="onRepublished">
    <span class="spinner-border spinner-border-sm me-2" v-show="isShowLoadingBtn()"></span>
    Повторить публикацию
  </button>
</template>

<script>
import {defineComponent, ref} from "vue"
import Api from "./services/Api"
import Notify from "@/services/Notify"
import {
  notesTypeId,
  promocodeTypeId,
  salesTypeId,
  offersTypeId,
  freeTypeId,
  foodAndProductsTypeId,
  banksTypeId,
  gamesTypeId,
  raffleTypeId, articlesTypeId
} from "@/modules/post/services/TypeId"

export default defineComponent({
  name: "Republished",
  props: {
    type: {
      type: String,
      required: true,
    },
    type_id: {
      type: String,
      required: false,
    },
    query: {
      type: Object,
      required: true,
    },
  },
  setup(props, {emit}) {
    let publishing = ref(false)

    function onRepublished() {
      if (confirm("Вы действительно хотите повторить публикацию?")) {
        startRepublishing()

        let handler
        let type = props["type"]
        let typeId = props["type_id"]

        if (type === "telegram") {
          handler = Api.telegramRepublished(
              telegramPrepareQuery(props["query"])
          )
        } else if (type === "site") {
          if (typeId === salesTypeId) {
            handler = Api.siteSalesRepublished(
                sitePrepareQuery(props["query"])
            )
          } else if (typeId === notesTypeId) {
            handler = Api.siteNotesRepublished(
                sitePrepareQuery(props["query"])
            )
          } else if (typeId === promocodeTypeId) {
            handler = Api.sitePromocodeRepublished(
                sitePrepareQuery(props["query"])
            )
          } else if (typeId === offersTypeId) {
            handler = Api.siteSalesRepublished(
                sitePrepareQuery(props["query"])
            )
          } else if (typeId === freeTypeId) {
            handler = Api.siteSalesRepublished(
                sitePrepareQuery(props["query"])
            )
          } else if (typeId === foodAndProductsTypeId) {
            handler = Api.siteSalesRepublished(
                sitePrepareQuery(props["query"])
            )
          } else if (typeId === banksTypeId) {
            handler = Api.siteSalesRepublished(
                sitePrepareQuery(props["query"])
            )
          } else if (typeId === gamesTypeId) {
            handler = Api.siteSalesRepublished(
                sitePrepareQuery(props["query"])
            )
          } else if (typeId === raffleTypeId) {
            handler = Api.siteSalesRepublished(
                sitePrepareQuery(props["query"])
            )
          } else if (typeId === articlesTypeId) {
            handler = Api.siteArticlesRepublished(
                sitePrepareQuery(props["query"])
            )
          } else {
            throw new Error("Неверный тип поста")
          }
        }

        handler.then(() => {
          // todo ХАК! небольшая отсрочка при загрузки от api
          // todo чтобы backend успел отложенно сделать все свои действия
          setTimeout(() => {
            emit('onRepublished', true)
          }, 1500)
        }).then(() => {
          Notify.success("Поставлена задача на повтор публикации.")
        }).catch(() => {
          emit('onRepublished', false)
        }).finally(() => {
          stopRepublishing()
        })
      }
    }

    function telegramPrepareQuery(q) {
      return {
        "post_id": getItem(q, "post_id"),
        "content": getItem(q, "content"),
        "image": getItem(q, "image"),
        "image_position": getItem(q, "image_position"),
        "scheduled_removed": getItem(q, "scheduled_removed"),
        "scheduled_published": getItem(q, "scheduled_published"),
        "button": getItem(q, "button"),
        "is_partner_links": getItem(q, "is_partner_links"),
        "comment_allow": getItem(q, "comment_allow"),
        "enable_rating": getItem(q, "enable_rating"),
        "type_commerce": getItem(q, "type_commerce"),
        "shop_id": getItem(q, "shop_id"),
        "category_id": getItem(q, "category_id"),
      };
    }

    function sitePrepareQuery(q) {
      return {
        "post_id": getItem(q, "post_id"),
        "content": getItem(q, "content"),
        "image": getItem(q, "image"),
        "image_position": getItem(q, "image_position"),
        "scheduled_removed": getItem(q, "scheduled_removed"),
        "scheduled_published": getItem(q, "scheduled_published"),
        "button": getItem(q, "button"),
        "is_partner_links": getItem(q, "is_partner_links"),
        "comment_allow": getItem(q, "comment_allow"),
        "enable_rating": getItem(q, "enable_rating"),
        "type_commerce": getItem(q, "type_commerce"),
        "shop_id": getItem(q, "shop_id"),
        "category_id": getItem(q, "category_id"),
        "type_id": getItem(q, "type_id"),
        "sub_type_ids": getItem(q, "sub_type_ids"),
        "title": getItem(q, "title"),
        "slug": getItem(q, "slug"),
        "type_visibility": getItem(q, "type_visibility"),
        "type_publish": getItem(q, "type_publish"),
        "first_order": getItem(q, "first_order"),
        "repeat_order": getItem(q, "repeat_order"),
        "price_new": getItem(q, "price_new"),
        "price_old": getItem(q, "price_old"),
        "promocode": getItem(q, "promocode"),
        "time_action_start": getItem(q, "time_action_start"),
        "time_action_end": getItem(q, "time_action_end"),
        "activate_link": getItem(q, "activate_link"),
        "action_activate_link": getItem(q, "action_activate_link"),
        "custom_link": getItem(q, "custom_link"),
        "sale_type_id": getItem(q, "sale_type_id"),
        "sale_type_value": getItem(q, "sale_type_value"),
        "tags_id": getItem(q, "tags_id"),
        "rating_article": getItem(q, "rating_article"),
        "faq": getItem(q, "faq"),
        "title_seo": getItem(q, "title_seo"),
        "description_seo": getItem(q, "description_seo"),
      };
    }

    function getItem(q, key) {
      return q?.[key] !== undefined ? q?.[key] : null
    }

    function isDisabledBtn() {
      return publishing.value === true
    }

    function isShowLoadingBtn() {
      return isDisabledBtn()
    }

    function startRepublishing() {
      publishing.value = true
    }

    function stopRepublishing() {
      publishing.value = false
    }

    return {
      onRepublished,
      isDisabledBtn,
      isShowLoadingBtn,
    }
  },
})
</script>

<style scoped>

</style>
